var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 33,
    viewBox: "0 0 41 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.375 4.39844C0.375 3.33757 0.796427 2.32016 1.54657 1.57001C2.29672 0.819865 3.31413 0.398438 4.375 0.398438H36.375C37.4359 0.398438 38.4533 0.819865 39.2034 1.57001C39.9536 2.32016 40.375 3.33757 40.375 4.39844V28.3984C40.375 29.4593 39.9536 30.4767 39.2034 31.2269C38.4533 31.977 37.4359 32.3984 36.375 32.3984H4.375C3.31413 32.3984 2.29672 31.977 1.54657 31.2269C0.796427 30.4767 0.375 29.4593 0.375 28.3984V4.39844ZM7.413 4.39844L20.375 15.7404L33.337 4.39844H7.413ZM36.375 7.05644L21.693 19.9044C21.3283 20.224 20.8599 20.4002 20.375 20.4002C19.8901 20.4002 19.4217 20.224 19.057 19.9044L4.375 7.05644V28.3984H36.375V7.05644Z",
    fill: "#FFF9EE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mail_icon.0228ba5c232c80682801088130181153.svg";
export { ForwardRef as ReactComponent };